import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/Login";
import DashboardPage from "@/pages/Dashboard";
import FlightsPage from "@/pages/Flights";
import GridsPage from "@/pages/Grids";
import ControlPointsPage from "@/pages/ControlPoints";
import GisPage from "@/pages/GisMap";
import DocumentProgressPage from "@/pages/DocumentProgress";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="p-10 text-slate-500">Memeriksa sesi...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  useEffect(() => { document.documentElement.classList.add("dark"); }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/flight" element={<FlightsPage />} />
            <Route path="/grid" element={<GridsPage />} />
            <Route path="/cp" element={<ControlPointsPage />} />
            <Route path="/dokumen" element={<DocumentProgressPage />} />
            <Route path="/gis" element={<GisPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
